import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { isMobile, isTablet, isMobileOnly } from 'react-device-detect';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LogInForm from './forms/LogInForm';
import logo from '../../img/logo/logo_light.svg';
import { signIn } from '../../redux/actions/authActions';
import { account_detail } from '../../redux/actions/accountActions';
import PrivacyPolicyLink from '../shared/components/PrivacyPolicyLink';
import './auth.css';
import AppBarPortal from '../shared/components/AppBarPortal';
import AppLeftPortal from '../shared/components/AppLeftPortal';
import AppFooterPortal from '../shared/components/AppFooterPortal';
import AppBarLandingMobile from '../shared/components/AppBarLandingMobile';
import DrawerLandingMobile from '../shared/components/DrawerLandingMobile';
import ReactGA from 'react-ga';

const styles = theme => ({
  root: {
    display: 'flex', 
    justifyContent: 'space-around', 
    alignItems: 'stretch', 
    flexFlow: 'column wrap'
  },
  item: {
    flexBasis: 'initial',
    flexGrow: 1,
    display: 'inline-flex'
  },
  buttonIndigo: theme.custom.button.indigo
})

class LogIn extends React.PureComponent {

  submit = values => {
    let data = new FormData()
    Object.keys(values).forEach((key) => {
      data.set(key, values[key])
    })
    
    this.props.dispatch(signIn(data));
  } 

  componentDidUpdate(prevProps, prevState) {
    console.debug(this.props)
    if (this.props.auth.is_authenticated === true) {
      ReactGA.event({
        category: 'Authentication',
        action: 'login_success',
        label: 'Auth'
      });

      this.props.dispatch(account_detail(this.props.auth.user_id))
      setTimeout(()=>this.props.history.push('/account/profile'),2000);
      ;
    }
  }

  componentDidMount() {
    if (this.props.auth.is_authenticated === true) {
      window.location = '/account/profile'
    }
    document.body.classList.add("login");
  }

  componentWillUnmount() {
    document.body.classList.remove("login");
  }

  render() {
    const { classes } = this.props

    return (
      <React.Fragment>
      {isMobileOnly && <AppBarLandingMobile hideLogo />}
      {isMobileOnly && <DrawerLandingMobile />}
        
        <main>
          {!isMobileOnly && <AppBarPortal />}
          {!isMobileOnly && <AppLeftPortal />}
          {!isMobileOnly && <AppFooterPortal />}


          
          
          <Grid container className={classes.root} spacing={8} alignItems="center">
          
            <Grid item xs={12} className={classes.item} style={{flexGrow: 1, justifyContent: 'center'}}>
              <img src={logo} style={{maxHeight: 36}} />
            </Grid>
          

            <Grid item xs={12} className={classes.item} style={{flexGrow: 2, alignItems: 'center', justifyContent: 'center', flexDirection: 'column', textAlign: 'center'}}>
       
              <Typography paragraph variant='headline'>Estudios &amp; análisis de productos cosméticos<br /></Typography>
              <Typography variant='headline' style={{fontSize: '1.1rem', color: '#424242'}}>Iniciar sesión </Typography>
            </Grid>

            <Grid item xs={12} className={classes.item} style={{flexGrow: 4, alignItems: 'flex-start'}}>
              <LogInForm onSubmit={this.submit} {...this.props} />
            </Grid>

            <Grid item xs={12} className={classes.item} style={{flexGrow: 1, alignItems: 'flex-end', justifyContent: 'center'}}>
              <PrivacyPolicyLink />
            </Grid>

          </Grid>
        </main>

      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.auth
  };
};

export default withRouter(
  connect(mapStateToProps)(
    withStyles(styles, {withTheme: true})(LogIn)
  )
);


// WEBPACK FOOTER //
// ./src/modules/auth/LogIn.js